

































import { Bank } from "@/types";
import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "SupportedBanks",

  props: {
    value: {
      type: String,
      default: "",
    },
  },

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.bankSelected = newValue;
      },
    },
    bankSelected: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.$emit("input", newValue);
      },
    },
  },

  mounted(): void {
    this.fetchBanks();
  },
  data: () => ({
    fetched: false,
    bankSelected: "",
  }),
  computed: {
    ...mapGetters({
      banks: "bankstatement/getBanks",
    }),
    // We solely do this to get some typing back
    typedBanks(): Bank[] {
      return this.banks;
    },

    nameBankSelected(): string {
      const selectedBank = this.typedBanks.find(
        (bank) => bank.id === this.bankSelected
      );
      return selectedBank ? selectedBank.name : "";
    },
  },
  methods: {
    async fetchBanks() {
      try {
        await this.$store.dispatch("bankstatement/fetchBanks");
      } finally {
        this.fetched = true;
      }
    },
    redirectToBank(bankId: string): void {
      this.$store
        .dispatch("bankstatement/fetchConsentLink", bankId)
        .then((res) => {
          window.location.href = res.data;
        });
    },
  },
});
